import { useAuth } from '@wix/cli-auth';
import { useMemo } from 'react';
import { VeloTypesSyncClient } from './velo-types-sync-client.js';

export function useVeloTypesSyncClient(projectFolder: string) {
  const { getAccessToken } = useAuth();

  return useMemo(
    () => new VeloTypesSyncClient(projectFolder, getAccessToken),
    [projectFolder, getAccessToken]
  );
}
